import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  &&& {
    background: none;
    background: transparent;
    color: ${pickThemeColor('RED_CORAL')} !important;
    ${pickThemeFontStyles('16', '20', 'NORMAL')};
    box-shadow: none;
    border: none !important;
    padding: 0;
  }
`;
